import { useToastController } from '@routable/gross-ds';
import { queryContext } from '@routable/shared';
import { useMutation } from '@tanstack/react-query';
import { annotationService } from './annotation.service';
export const useAnnotationCancelReview = (annotationId) => {
    const toast = useToastController();
    return useMutation({
        mutationFn: () => annotationService.cancelReview({ annotationId }),
        context: queryContext,
        onError: () => {
            toast.addToast({
                type: 'critical',
                message: 'Something went wrong. Please try again.',
            });
        },
    });
};
